import { Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'

// Layout
import { Layout, ScrollToTop } from '@/components/layout'

// Public Pages
const HomePage = lazy(() => import('@/pages/public/HomePage'))
const AboutPage = lazy(() => import('@/pages/public/AboutPage'))
const ProductsPage = lazy(() => import('@/pages/public/ProductsPage'))
const CategoryPage = lazy(() => import('@/pages/public/CategoryPage'))
const ProductDetailPage = lazy(() => import('@/pages/public/ProductDetailPage'))
const GalleryPage = lazy(() => import('@/pages/public/GalleryPage'))
const CertificatesPage = lazy(() => import('@/pages/public/CertificatesPage'))
const ContactPage = lazy(() => import('@/pages/public/ContactPage'))
const SustainabilityPage = lazy(() => import('@/pages/public/SustainabilityPage'))
const QuoteBasketPage = lazy(() => import('@/pages/public/QuoteBasketPage'))
const ComingSoonPage = lazy(() => import('@/pages/public/ComingSoonPage'))
const CatalogRequestPage = lazy(() => import('@/pages/public/CatalogRequestPage'))

// Admin Pages
const LoginPage = lazy(() => import('@/pages/admin/LoginPage'))
const DashboardPage = lazy(() => import('@/pages/admin/DashboardPage'))
const ProductsListPage = lazy(() => import('@/pages/admin/ProductsListPage'))
const ProductFormPage = lazy(() => import('@/pages/admin/ProductFormPage'))
const CategoriesPage = lazy(() => import('@/pages/admin/CategoriesPage'))
const ConfiguratorTemplatesPage = lazy(() => import('@/pages/admin/ConfiguratorTemplatesPage'))
const QuotesPage = lazy(() => import('@/pages/admin/QuotesPage'))
const AdminGalleryPage = lazy(() => import('@/pages/admin/GalleryPage'))
const AdminCertificatesPage = lazy(() => import('@/pages/admin/CertificatesPage'))
const SubscribersPage = lazy(() => import('@/pages/admin/SubscribersPage'))
const MessagesPage = lazy(() => import('@/pages/admin/MessagesPage'))
const SettingsPage = lazy(() => import('@/pages/admin/SettingsPage'))
const HomepageBlocksPage = lazy(() => import('@/pages/admin/HomepageBlocksPage'))
const PageContentEditor = lazy(() => import('@/pages/admin/PageContentEditor'))
const CompanyValuesPage = lazy(() => import('@/pages/admin/CompanyValuesPage'))
const CompanyLocationsPage = lazy(() => import('@/pages/admin/CompanyLocationsPage'))
const CatalogsPage = lazy(() => import('@/pages/admin/CatalogsPage'))
const CatalogRequestsPage = lazy(() => import('@/pages/admin/CatalogRequestsPage'))
const FileManagerPage = lazy(() => import('@/pages/admin/FileManagerPage'))
const LiveChatPage = lazy(() => import('@/pages/admin/LiveChatPage'))

// Admin Layout
import { AdminLayout } from '@/components/admin'

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
  </div>
)

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:categorySlug" element={<CategoryPage />} />
          <Route path="/products/:categorySlug/:productSlug" element={<ProductDetailPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/certificates" element={<CertificatesPage />} />
          <Route path="/sustainability" element={<SustainabilityPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/quote-basket" element={<QuoteBasketPage />} />
          <Route path="/catalog-request" element={<CatalogRequestPage />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="products" element={<ProductsListPage />} />
          <Route path="products/new" element={<ProductFormPage />} />
          <Route path="products/:id" element={<ProductFormPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="configurators" element={<ConfiguratorTemplatesPage />} />
          <Route path="quotes" element={<QuotesPage />} />
          <Route path="gallery" element={<AdminGalleryPage />} />
          <Route path="certificates" element={<AdminCertificatesPage />} />
          <Route path="subscribers" element={<SubscribersPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="homepage" element={<HomepageBlocksPage />} />
          <Route path="pages/:pageSlug" element={<PageContentEditor />} />
          <Route path="company-values" element={<CompanyValuesPage />} />
          <Route path="company-locations" element={<CompanyLocationsPage />} />
          <Route path="catalogs" element={<CatalogsPage />} />
          <Route path="catalog-requests" element={<CatalogRequestsPage />} />
          <Route path="file-manager" element={<FileManagerPage />} />
          <Route path="live-chat" element={<LiveChatPage />} />
          <Route path="certifications" element={<AdminCertificatesPage />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default App
